module.exports = __webpack_public_path__ + "static/img/73 (3).5de38c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/73 (3).jpg
// module id = x/tm
// module chunks = 0